<div class="use_trinka_other_app trinka-banner section-pd-sm">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="trinka-title mb-0 text-center">
                    <h3 class="text-white mb-4">在其他應用程式中使用Trinka</h3>
                </div>
                <div class="use_trinka_content">
                    <div class="others_app_name">
                        <ul>
                            <li>
                                <a [routerLink]="['/trinkacloud']">
                                    <div class="app_name_content">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="/assets/images/Other_apps_TrinkaCloud.svg" alt="Free grammar checker tool">
                                        <h3>Cloud</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a [routerLink]="['/wordplugin']">
                                    <div class="app_name_content">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="/assets/images/wordAdd_in.svg" alt="word extension">
                                        <h3>MS Word</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a [routerLink]="['/browser-plugin']">
                                    <div class="app_name_content">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="/assets/images/NewChromeIcon.svg" alt="chrome extension">
                                        <h3>Chrome</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a  [routerLink]="['/browser-plugin']">
                                    <div class="app_name_content">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="/assets/images/NewFirefoxIcon.svg" alt="firefox extension">
                                        <h3>Firefox</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a [routerLink]="['/browser-plugin']">
                                    <div class="app_name_content">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="/assets/images/EdgeWhite_BGAndOutline.svg" alt="edge extension">
                                        <h3>Edge</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a [routerLink]="['/windows-desktop-app']">
                                    <div class="app_name_content">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="/assets/images/windows-apps-for-grammar-checker.png" alt="windows apps for grammar checker">
                                        <h3>Windows App</h3>
                                    </div>
                                </a>
                            </li>

                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
